export const buttonTypes = {
    standard: "standard",
    deleteIcon: "deleteIcon",
    uploadIcon: "uploadIcon",
    removeIcon: "removeIcon",
    standardOutlinedPrimary: "standard-outlined-primary",
    standardContainedPrimary: "standard-contained-primary",
};